export var BUTTON_TYPE = {
    "button-link": "button-link",
    "button-anchor": "button-anchor"
};
export var UPRISE_TYPE = {
    "normal": "normal",
    "dropdown": 'dropdown',
    "colored": "colored",
};
//# sourceMappingURL=const.js.mapexport var BUTTON_TYPE = {
    "button-link": "button-link",
    "button-anchor": "button-anchor"
};
export var UPRISE_TYPE = {
    "normal": "normal",
    "dropdown": 'dropdown',
    "colored": "colored",
};
//# sourceMappingURL=const.js.map